import { graphql } from "gql";

const CREATE_USER_LIST_MUTATION = graphql(`
  mutation CreateUserList($input: CreateUserInput!) {
    createUserList(input: $input) {
      ...User
    }
  }
`);

export default CREATE_USER_LIST_MUTATION;
